var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toggle",on:{"click":function($event){return _vm.$emit('toggle-theme')}}})}
var staticRenderFns = []

export { render, staticRenderFns }